import styled, { Device, Scale, breakpoints } from '@secretescapes/falcon';

export const MobileContainer = styled('div')`
  display: block;
  visibility: visible;

  @media (min-width: ${breakpoints[Device.tablet]}) {
    display: none;
    visibility: hidden;
  }
`;

export const DesktopContainer = styled('div')`
  display: none;
  visibility: hidden;

  @media (min-width: ${breakpoints[Device.tablet]}) {
    display: grid;
    visibility: visible;
  }
`;

export const ActionButton = styled('button')`
  position: absolute;
  bottom: ${Scale.m};
  right: ${Scale.m};
  display: flex;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.7);
  border: 0;
  border-radius: ${Scale.xxs};
  padding: ${Scale.xxs} ${Scale.xs};
  z-index: 2;
  cursor: pointer;

  @media (min-width: ${breakpoints[Device.tablet]}) {
    gap: ${Scale.xs};
    padding: ${Scale.xs} ${Scale.m};
  }
`;
